export var getCartProductQuantitiesMap = function(items) {
    var itemQuantitiesMap = {};
    items.forEach(function(item) {
        if (!(item === null || item === void 0 ? void 0 : item.product_token)) {
            return;
        }
        var _itemQuantitiesMap_item_product_token, _item_quantity;
        itemQuantitiesMap[item.product_token] = ((_itemQuantitiesMap_item_product_token = itemQuantitiesMap[item.product_token]) !== null && _itemQuantitiesMap_item_product_token !== void 0 ? _itemQuantitiesMap_item_product_token : 0) + ((_item_quantity = item.quantity) !== null && _item_quantity !== void 0 ? _item_quantity : 0);
    });
    return itemQuantitiesMap;
};
export var getCartProductOptionQuantitiesMap = function(items) {
    var itemQuantitiesMap = {};
    items.forEach(function(item) {
        if (!(item === null || item === void 0 ? void 0 : item.product_option_token)) {
            return;
        }
        var _itemQuantitiesMap_item_product_option_token, _item_quantity;
        itemQuantitiesMap[item.product_option_token] = ((_itemQuantitiesMap_item_product_option_token = itemQuantitiesMap[item.product_option_token]) !== null && _itemQuantitiesMap_item_product_option_token !== void 0 ? _itemQuantitiesMap_item_product_option_token : 0) + ((_item_quantity = item.quantity) !== null && _item_quantity !== void 0 ? _item_quantity : 0);
    });
    return itemQuantitiesMap;
};
